import { Stack } from "@mui/material";
import { useCountdownMinutes } from "../../hooks/useCountdownMinutes";
import { ApproximateTimeText } from "./ApproximateTimeText";
import { ClockOutlineIcon } from "../images/ClockOutlineIcon";

type Props = {
  id: string;
  seconds: number | undefined;
  itemsKey: string;
};

export const ApproximateTimeLabel = ({ id, seconds, itemsKey }: Props) => {
  const minutes = useCountdownMinutes(id, seconds, itemsKey);

  if (minutes <= 0) return null;

  return (
    <Stack direction="row" alignItems="center" gap="4px">
      <ClockOutlineIcon />
      <ApproximateTimeText id={id} seconds={seconds} itemsKey={itemsKey} />
    </Stack>
  );
};
